module.exports = __webpack_public_path__ + "public/Icons/2sitesettings.svg?3f62a777";